module.exports = __webpack_public_path__ + "65fecda00937aa8b6917c3118f5d0457.svg";